function getWindowLocationOrigin() {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.origin.replace(/\/$/, '');
}

function getDerivedPublicOrigin() {
  if (typeof window === 'undefined') {
    return '';
  }

  const { protocol, hostname, port } = window.location;
  const lowerHost = hostname.toLowerCase();

  if (
    lowerHost === 'localhost' ||
    lowerHost === '127.0.0.1' ||
    lowerHost === '[::1]'
  ) {
    return getWindowLocationOrigin();
  }

  const appSubdomains = ['admin.', 'portal.', 'support.', 'status.', 'store.', 'b2b.', 'distrogrid.'];
  const matchingSubdomain = appSubdomains.find((prefix) => lowerHost.startsWith(prefix));
  if (!matchingSubdomain) {
    return getWindowLocationOrigin();
  }

  const publicHost = hostname.slice(matchingSubdomain.length);
  const portSuffix = port ? `:${port}` : '';
  return `${protocol}//${publicHost}${portSuffix}`;
}

export function getBackendBaseUrl() {
  const appHost =
    typeof window !== 'undefined' &&
    ['admin.', 'portal.', 'store.', 'b2b.', 'distrogrid.'].some((prefix) => window.location.hostname.toLowerCase().startsWith(prefix));
  const adminBackendUrl = (process.env.REACT_APP_ADMIN_BACKEND_URL || '').trim().replace(/\/$/, '');
  const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');

  if (appHost) {
    return adminBackendUrl || getWindowLocationOrigin();
  }

  return backendUrl || getWindowLocationOrigin();
}

export function getPublicSiteOrigin() {
  const configuredOrigin = (
    process.env.REACT_APP_PUBLIC_FRONTEND_URL ||
    process.env.REACT_APP_FRONTEND_URL ||
    ''
  ).trim().replace(/\/$/, '');

  return configuredOrigin || getDerivedPublicOrigin() || getWindowLocationOrigin();
}

export function buildPublicSiteUrl(path = '') {
  const origin = getPublicSiteOrigin();
  const normalizedPath = path
    ? path.startsWith('/')
      ? path
      : `/${path}`
    : '';

  return `${origin}${normalizedPath}`;
}
